// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file non_medical_master/create_non_medical_master.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { NonMedicalMasterMetadata } from "./common_pb.js";
import { TaxProfile } from "../medical_master/common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.CreateNonMedicalMasterRequest
 */
export class CreateNonMedicalMasterRequest extends Message<CreateNonMedicalMasterRequest> {
  /**
   * @generated from field: string trade_name = 1;
   */
  tradeName = "";

  /**
   * @generated from field: int32 unit = 2;
   */
  unit = 0;

  /**
   * @generated from field: string unit_type = 3;
   */
  unitType = "";

  /**
   * @generated from field: string barcode = 4;
   */
  barcode = "";

  /**
   * @generated from field: com.neulink.pharmacy.NonMedicalMasterMetadata metadata = 5;
   */
  metadata?: NonMedicalMasterMetadata;

  /**
   * @generated from field: com.neulink.pharmacy.TaxProfile tax_profile = 6;
   */
  taxProfile?: TaxProfile;

  constructor(data?: PartialMessage<CreateNonMedicalMasterRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreateNonMedicalMasterRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "trade_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "unit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "unit_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "barcode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "metadata", kind: "message", T: NonMedicalMasterMetadata },
    { no: 6, name: "tax_profile", kind: "message", T: TaxProfile },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateNonMedicalMasterRequest {
    return new CreateNonMedicalMasterRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateNonMedicalMasterRequest {
    return new CreateNonMedicalMasterRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateNonMedicalMasterRequest {
    return new CreateNonMedicalMasterRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateNonMedicalMasterRequest | PlainMessage<CreateNonMedicalMasterRequest> | undefined, b: CreateNonMedicalMasterRequest | PlainMessage<CreateNonMedicalMasterRequest> | undefined): boolean {
    return proto3.util.equals(CreateNonMedicalMasterRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.CreateNonMedicalMasterResponse
 */
export class CreateNonMedicalMasterResponse extends Message<CreateNonMedicalMasterResponse> {
  /**
   * Unique identifier for the created non-medical master
   *
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<CreateNonMedicalMasterResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreateNonMedicalMasterResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateNonMedicalMasterResponse {
    return new CreateNonMedicalMasterResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateNonMedicalMasterResponse {
    return new CreateNonMedicalMasterResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateNonMedicalMasterResponse {
    return new CreateNonMedicalMasterResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateNonMedicalMasterResponse | PlainMessage<CreateNonMedicalMasterResponse> | undefined, b: CreateNonMedicalMasterResponse | PlainMessage<CreateNonMedicalMasterResponse> | undefined): boolean {
    return proto3.util.equals(CreateNonMedicalMasterResponse, a, b);
  }
}

